/* unplugin-vue-components disabled */import { render } from "./StereoProjectionEditor.vue?vue&type=template&id=42b61990&scoped=true"
import script from "./StereoProjectionEditor.vue?vue&type=script&lang=js"
export * from "./StereoProjectionEditor.vue?vue&type=script&lang=js"

import "./StereoProjectionEditor.vue?vue&type=style&index=0&id=42b61990&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b61990"]])

export default __exports__